import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../strings.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingPage17xvcovc6b4n0 as LandingPage } from './LandingScreen.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull,
  get_currentSession2ignzypsmrqzv as get_currentSession,
} from '../sdk/currentSession.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  FamilyApplication2f6semoy1a9hz as FamilyApplication,
  ProviderApplicationj6elx51glw3 as ProviderApplication,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  get_notNull2od35hy6ssmdh as get_notNull,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_invitedUsers2grm04jnkmtlg as get_invitedUsers,
  get_review35f4yosw8k9cn as get_review,
  get_invitedUsers2sllg41nh1v2v as get_invitedUsers_0,
  get_reviewjqvgm91l8fp3 as get_review_0,
  get_submitted382abp2i1n972 as get_submitted,
  get_approved221jlb71nbap0 as get_approved,
  get_periodnytt0bk9l5et as get_period,
  get_start1ib7kl469eh9c as get_start,
  get_submissionxklyxsg05uep as get_submission,
  get_submission3ha7ltsjel3fd as get_submission_0,
  get__id1hi7gtah39onn as get__id,
  get_voided2matvha0tyhkf as get_voided,
  get_family3q4ofyk7cegoi as get_family,
  get_forDate3tzeotrzulxwz as get_forDate,
  get_available29p7gsw45t1wj as get_available,
  get_employerfduycfo0q5pn as get_employer,
  get_breakdown3ggnps1coozif as get_breakdown,
  get_month19qfpo3x38uey as get_month,
  get_endInclusive3dsvnewm08bor as get_endInclusive,
  get_active17ysivz5d1f67 as get_active,
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_endInclusive2wh7ub8763o5h as get_endInclusive_0,
  get_activeRange2dh4qyh6z7x7z as get_activeRange_0,
  get_start30tbw38mnjak0 as get_start_0,
  get_date13hdmf8teioql as get_date,
  get_familyraw6f29ztw22 as get_family_0,
  get_childName2bddylpcm0ja3 as get_childName,
  get_takerType1ndu8mc2kn1bw as get_takerType,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { ID2ebczrc12h07k as ID } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import {
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
  gte1zw995v5ulf70 as gte,
  lt30kf68e33bhtj as lt,
  lte2qmhlnwrclg8p as lte,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  SetAnyElements2se8zlywewplk as SetAnyElements,
  and3dbt2f202um49 as and,
  or1uh2qn0k1rz6c as or,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  isBackOfficeUser15lhmu7ztwvih as isBackOfficeUser,
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
  managesLocations3e0r20fvtj1ym as managesLocations,
  managesProviders2tknldxk4b8ta as managesProviders,
  managesFamiliesklgx21qxhvef as managesFamilies,
  managesSomething2ap6xsvopocgf as managesSomething,
} from '../App.mjs';
import {
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  ID1z61wlmtvxrjn as ID_0,
  Employer27b20p5x27kte as Employer,
  _ID___init__impl__k1lb7eetc5oa5dx2ra as _ID___init__impl__k1lb7e,
  IDjecfjjw6mot9 as ID_1,
  _ID___init__impl__k1lb7e213aw7xpq3qqc as _ID___init__impl__k1lb7e_0,
  IDqqik72jjbpsn as ID_2,
  _ID___init__impl__k1lb7e1lquexfyufrn6 as _ID___init__impl__k1lb7e_1,
  ID1m87d1hextx54 as ID_3,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  FamilyEmployerAuthorizationz43b3id5q687 as FamilyEmployerAuthorization,
  CareLocationClosure1da03s5ze3kft as CareLocationClosure,
  _ID___get_raw__impl__92g6u53v684soiyq5c7 as _ID___get_raw__impl__92g6u5,
  _ID___get_raw__impl__92g6u538uvogo1uv277 as _ID___get_raw__impl__92g6u5_0,
  _ID___get_raw__impl__92g6u53scm0g2ugxj1p as _ID___get_raw__impl__92g6u5_1,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  BilledDayTotals2enuwcjtkow7 as BilledDayTotals,
  SingleChildDayfsi906tc8dp6 as SingleChildDay,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import {
  Survey1bcnex3xrekf as Survey,
  ID3b6wrkk3fpdmq as ID_4,
  SurveyProgress2a3z8tdqg3ffh as SurveyProgress,
  Audience_AnonymousEmployee_getInstance2bv7u5yl59uph as Audience_AnonymousEmployee_getInstance,
  nextTakingDate2z4ej6zmlzj64 as nextTakingDate,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  today1rno4frfjp5oe as today,
  nowLocal2mdv5rmil2cf2 as nowLocal,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { SurveyTakePage3k2il0je8ciy as SurveyTakePage } from './surveys/SurveyTakePage.mjs';
import { AnonymousSurveyPage31h992m9jks1x as AnonymousSurveyPage } from './surveys/AnonymousSurveyPage.mjs';
import { AttendancePeriodDetailPage2fnxdkx3t2m6k as AttendancePeriodDetailPage } from './attendance/AttendancePeriodDetailPage.mjs';
import { FamilyApplicationDetailPage3ca1ne4h64yjy as FamilyApplicationDetailPage } from './applications/FamilyApplicationDetailPage.mjs';
import {
  text189ciz0cnr32o as text,
  h12aidul0n4qlwh as h1,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3 } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { ProviderApplicationDetailPage2kxg2k1w3bu5h as ProviderApplicationDetailPage } from './applications/ProviderApplicationDetailPage.mjs';
import { ChildPlacementDetailPagewfmc55i6s15v as ChildPlacementDetailPage } from './children/ChildPlacementDetailPage.mjs';
import { FamilyDetailPage2yycb034kbs09 as FamilyDetailPage } from './families/FamilyDetailPage.mjs';
import { CloseOutPagesekceysksiq3 as CloseOutPage } from './closeout/CloseOutPage.mjs';
import { LocationDetailPage2zka4ek7qyuhq as LocationDetailPage } from './locations/LocationDetailPage.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { EmployerMonthAggregates15vmzuxkabqjv as EmployerMonthAggregates } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/employerAggregations.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents1lsbs5l1tlgw as Cents,
} from '../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { reactiveLabel206b3aonybuoa as reactiveLabel } from './components/view-utilities.mjs';
import {
  styledHeaderwng1nfqibdig as styledHeader,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
} from '../theme/semantics.mjs';
import { EmployerMonthsPagesopligyz03kb as EmployerMonthsPage } from './employers/EmployerMonthsPage.mjs';
import { EmployerTransactionsPageanwqvpujplg1 as EmployerTransactionsPage } from './employers/EmployerTransactionsPage.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import {
  plus1oi9f9vif99u2 as plus,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { eachCount1imd75z0wkpbt as eachCount } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/GroupingJs.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  colOf78ko504rukk8 as colOf,
  colOfv2oygjkn5hb2 as colOf_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HomePage$_get_title_$lambda_loyj5k($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homePageTitle_o7pge7_k$();
}
function HomePage$render$lambda$slambda($this_render) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(50n, $completion);
    get_pageNavigator($this_render.get_context_h02k06_k$()).reset_diztr_k$(new (LandingPage())());
    return Unit_instance;
  }), 1);
}
function HomePage$render$lambda($this$remember) {
  var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
  var tmp = session.get_familyApplications_uxaw4w_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  // Inline function 'com.lightningkite.services.database.any' call
  var this_0 = get_invitedUsers(it);
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(ID()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var u = new (DataClassPathSelf())(tmp$ret$12);
  var tmp$ret$13 = eq(u, new (ID())(session.userId_1));
  var tmp$ret$10 = this_0.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$13));
  var tmp$ret$4 = and(tmp$ret$10, eq(get_review(it), null));
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function HomePage$render$lambda_0($this$remember) {
  var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
  var tmp = session.get_providerApplications_bz9fcz_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(ProviderApplication()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(ProviderApplication()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  // Inline function 'com.lightningkite.services.database.any' call
  var this_0 = get_invitedUsers_0(it);
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(ID()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var u = new (DataClassPathSelf())(tmp$ret$12);
  var tmp$ret$13 = eq(u, new (ID())(session.userId_1));
  var tmp$ret$10 = this_0.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$13));
  var tmp$ret$4 = and(tmp$ret$10, eq(get_review_0(it), null));
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function HomePage$render$lambda_1($this$remember) {
  if (!isBackOfficeUser($this$remember)) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }
  var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$3);
  var tmp_1 = and(neq(get_submitted(it), null), eq(get_approved(it), null));
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
  var tmp$ret$10 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_0.ascending_ijynum_k$(get_start(get_period(it_0)));
  var tmp$ret$6 = this_0.build_1k0s4u_k$();
  return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$6)));
}
function HomePage$render$lambda_2($this$remember) {
  if (!isBackOfficeUser($this$remember)) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }
  var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyApplications_uxaw4w_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$3);
  var tmp$ret$1 = and(neq(get_submission(it), null), eq(get_review(it), null));
  return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp$ret$1)));
}
function HomePage$render$lambda_3($this$remember) {
  if (!isBackOfficeUser($this$remember)) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }
  var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_providerApplications_bz9fcz_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(ProviderApplication()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$3);
  var tmp$ret$1 = and(neq(get_submission_0(it), null), eq(get_review_0(it), null));
  return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp$ret$1)));
}
var HomePage$render$1$$inlined$groupingBy$1Class;
function HomePage$render$1$$inlined$groupingBy$1() {
  if (HomePage$render$1$$inlined$groupingBy$1Class === VOID) {
    class $ {
      constructor($this) {
        this.$this_1 = $this;
      }
      sourceIterator_2zqxcn_k$() {
        return this.$this_1.iterator_jk1svi_k$();
      }
      keyOf_qdhuon_k$(element) {
        return new (ID_0())(element.location_1);
      }
      keyOf_d1fr09_k$(element) {
        return this.keyOf_qdhuon_k$(element);
      }
    }
    initMetadataForClass($);
    HomePage$render$1$$inlined$groupingBy$1Class = $;
  }
  return HomePage$render$1$$inlined$groupingBy$1Class;
}
function HomePage$render$lambda_4($this$remember) {
  var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
  var ids = $this$remember.invoke_r7m7el_k$(session.managedEmployers_1);
  if (ids.isEmpty_y1axqb_k$()) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }
  var tmp = session.get_employers_iw3lox_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$3);
  var tmp$ret$1 = xDataClassPathInsideSet(get__id(it), ids);
  return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp$ret$1)));
}
function HomePage$render$slambda($startOfYear) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = session.managedFamilies_1;
    var families = yield* await_0(this_1, $completion);
    var tmp;
    if (families.isEmpty_y1axqb_k$()) {
      return new (BilledDayTotals())();
    }
    var tmp_0 = session.api_1.get_singleChildDay_52scz3_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$4);
    var tmp$ret$2 = and(and(eq(get_voided(it), null), xDataClassPathInsideSet(get_family(it), families)), gte(get_forDate(it), $startOfYear));
    var tmp0 = (yield* tmp_0.totalsByPlacement_39jjrf_k$(tmp$ret$2, $completion)).get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (BilledDayTotals())();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      accumulator = accumulator.plus_8jdhal_k$(element);
    }
    return accumulator;
  }), 1);
}
function HomePage$render$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_appTagline_r1snd6_k$();
}
function HomePage$render$lambda_6($this$remember) {
  var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$(get_currentSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  var tmp_0 = session.get_surveys_tdixlc_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Survey()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$3);
  var tmp$ret$1 = neq(get_available(it), null);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp$ret$1, VOID, VOID, 2147483647)));
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (ensureNotNull(element.available_1).contains_pio7lx_k$(today())) {
      destination.add_utx5q5_k$(element);
    }
  }
  return destination;
}
function HomePage$render$lambda_7(_destruct__k2r9zo) {
  var survey = _destruct__k2r9zo.component1_7eebsc_k$();
  var takerId = _destruct__k2r9zo.component2_7eebsb_k$();
  return to(new (ID_4())(survey._id_1), takerId);
}
function HomePage$render$lambda_8($this$colOf, pending) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => 'Survey: ' + $this$invoke.invoke_r7m7el_k$(pending).first_1.name_1);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var _destruct__k2r9zo = $this$invoke.invoke_r7m7el_k$(pending);
    var survey = _destruct__k2r9zo.component1_7eebsc_k$();
    var takerId = _destruct__k2r9zo.component2_7eebsb_k$();
    var session = $this$invoke.invoke_r7m7el_k$(get_currentSession());
    var tmp;
    switch (survey.audience_1.ordinal_1) {
      case 1:
        var tmp2_safe_receiver = session == null ? null : session.get_families_is4v1x_k$();
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.get_6ueaa7_k$(new (ID_1())(_ID___init__impl__k1lb7e(takerId)));
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : $this$invoke.invoke_r7m7el_k$(tmp3_safe_receiver);
        tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.get_distinctName_5wyy9c_k$();
        break;
      case 2:
        var tmp6_safe_receiver = session == null ? null : session.get_employers_iw3lox_k$();
        var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.get_6ueaa7_k$(new (ID_2())(_ID___init__impl__k1lb7e_0(takerId)));
        var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : $this$invoke.invoke_r7m7el_k$(tmp7_safe_receiver);
        tmp = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.name_1;
        break;
      case 3:
        var tmp10_safe_receiver = session == null ? null : session.get_careProviders_b5tc2w_k$();
        var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.get_6ueaa7_k$(new (ID_3())(_ID___init__impl__k1lb7e_1(takerId)));
        var tmp12_safe_receiver = tmp11_safe_receiver == null ? null : $this$invoke.invoke_r7m7el_k$(tmp11_safe_receiver);
        tmp = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.name_1;
        break;
      case 0:
        tmp = null;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var name = tmp;
    return 'For ' + (name == null ? '' : name);
  });
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = Link$_get_to_$ref_jq7esp(element);
  var tmp_7 = getPropertyCallableRef('to', 0, tmp_5, tmp_6, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
    // Inline function 'kotlin.let' call
    var destruct = $this$invoke.invoke_r7m7el_k$(pending);
    var survey = destruct.component1_7eebsc_k$();
    var takerId = destruct.component2_7eebsb_k$();
    return () => new (SurveyTakePage())(survey._id_1, takerId);
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_9(_destruct__k2r9zo) {
  var survey = _destruct__k2r9zo.component1_7eebsc_k$();
  var employer = _destruct__k2r9zo.component2_7eebsb_k$().raw_1;
  return to(new (ID_4())(survey._id_1), new (ID_2())(employer));
}
function HomePage$render$lambda_10($this$colOf, shared) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => 'Share with your employees: ' + $this$invoke.invoke_r7m7el_k$(shared).first_1.name_1);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(get_currentSession());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_employers_iw3lox_k$();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_6ueaa7_k$($this$invoke.invoke_r7m7el_k$(shared).second_1);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : $this$invoke.invoke_r7m7el_k$(tmp2_safe_receiver);
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.name_1;
    return 'Open this survey and send its address to employees of ' + (tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs) + '.';
  });
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = Link$_get_to_$ref_jq7esp(element);
  var tmp_7 = getPropertyCallableRef('to', 0, tmp_5, tmp_6, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
    // Inline function 'kotlin.let' call
    var destruct = $this$invoke.invoke_r7m7el_k$(shared);
    var survey = destruct.component1_7eebsc_k$();
    var employer = destruct.component2_7eebsb_k$().raw_1;
    return () => new (AnonymousSurveyPage())(survey._id_1, employer);
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_11($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeEmptyStateMessage_lc9n17_k$();
}
function HomePage$render$lambda_12($this$shownWhen) {
  return isBackOfficeUser($this$shownWhen);
}
function HomePage$render$lambda_13($this$styledHeader) {
  return 'Attendance awaiting approval';
}
function HomePage$render$lambda_14($this$colOf, period) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (AttendancePeriodDetailPage())($this$invoke.invoke_r7m7el_k$(period)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(period).location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(period).period_1.toString());
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_15($this$styledHeader) {
  return 'Attendance overdue';
}
function HomePage$render$lambda_16($this$colOf, period) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (AttendancePeriodDetailPage())($this$invoke.invoke_r7m7el_k$(period)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(period).location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(period).period_1.toString() + ' \xB7 not submitted');
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_17($this$styledHeader) {
  return 'Applications to review';
}
function HomePage$render$lambda_18($this$colOf, application) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (FamilyApplicationDetailPage())($this$invoke.invoke_r7m7el_k$(application)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  text(get_bold(element_0), 'Family application');
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => EmailAddress__toString_impl_artjh3($this$invoke.invoke_r7m7el_k$(application).sentTo_1));
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_19($this$colOf, application) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (ProviderApplicationDetailPage())($this$invoke.invoke_r7m7el_k$(application)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  text(get_bold(element_0), 'Provider application');
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => EmailAddress__toString_impl_artjh3($this$invoke.invoke_r7m7el_k$(application).sentTo_1));
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_20($this$styledHeader) {
  return 'Placements ending in the next 30 days';
}
function HomePage$render$lambda_21($this$colOf, placement) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (ChildPlacementDetailPage())($this$invoke.invoke_r7m7el_k$(placement)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(placement).childName_1);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(placement).location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    var location = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    return location + ' \xB7 ends ' + toString($this$invoke.invoke_r7m7el_k$(placement).activeRange_1.endInclusive_1);
  });
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_22($this$styledHeader) {
  return 'Employer authorizations ending in the next 30 days';
}
function HomePage$render$lambda_23($this$colOf, authorization) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (FamilyDetailPage())($this$invoke.invoke_r7m7el_k$(authorization).family_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$().get_6ueaa7_k$(new (ID_1())($this$invoke.invoke_r7m7el_k$(authorization).family_1)));
    var parent = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.primaryParent_1;
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = parent.firstName_1 + ' ' + parent.lastName_1;
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID_2())($this$invoke.invoke_r7m7el_k$(authorization).employer_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    var employer = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    return employer + ' \xB7 ends ' + $this$invoke.invoke_r7m7el_k$(authorization).activeRange_1.endInclusive_1.toString();
  });
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_24($this$invoke) {
  return HomePage$render$lambda$lambda;
}
function HomePage$render$lambda$lambda() {
  return new (CloseOutPage())();
}
function HomePage$render$lambda_25($this$shownWhen) {
  return managesLocations($this$shownWhen) || managesProviders($this$shownWhen);
}
function HomePage$render$lambda_26($this$styledHeader) {
  return 'Attendance to complete';
}
function HomePage$render$lambda_27($this$colOf, period) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (AttendancePeriodDetailPage())($this$invoke.invoke_r7m7el_k$(period)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(period).location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(period).period_1.toString() + ' \xB7 ' + $this$invoke.invoke_r7m7el_k$(period).get_status_jnf6d7_k$());
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_28($this$styledHeader) {
  return 'Children enrolled today';
}
function HomePage$render$lambda_29($this$colOf, entry) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (LocationDetailPage())($this$invoke.invoke_r7m7el_k$(entry).first_1.raw_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = weight(element_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$($this$invoke.invoke_r7m7el_k$(entry).first_1));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_2 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(entry).second_1.toString());
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_30($this$styledHeader) {
  return 'Closures in the next 30 days';
}
function HomePage$render$lambda_31($this$colOf, closure) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(closure).location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(closure).date_1.toString() + ' \xB7 ' + $this$invoke.invoke_r7m7el_k$(closure).reason_1.displayName_1);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_32($this$colOf, employer) {
  var lastMonth = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employerMonthAggregates_z5j4ls_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(EmployerMonthAggregates()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp_1 = and(eq(get_employer(it), new (ID_2())($this$remember.invoke_r7m7el_k$(employer)._id_1)), neq(get_breakdown(it), null));
    // Inline function 'com.lightningkite.services.database.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(EmployerMonthAggregates()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$9);
    this_0.descending_tl4o2_k$(get_month(it_0));
    var tmp$ret$5 = this_0.build_1k0s4u_k$();
    return firstOrNull($this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$5, VOID, 1))));
  });
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(employer).name_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  var tmp_2 = HomePage$render$lambda$lambda_0;
  reactiveLabel(element, tmp_2, ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(employer).balance_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.balance_1;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? 'Not synced yet' : tmp2_elvis_lhs;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(lastMonth) == null));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  styledHeader(element_1, ($this$styledHeader) => {
    var tmp0_safe_receiver = $this$styledHeader.invoke_r7m7el_k$(lastMonth);
    return 'Last complete month: ' + toString(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.month_1);
  });
  var tmp_3 = HomePage$render$lambda$lambda_1;
  reactiveLabel(element_1, tmp_3, ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(lastMonth);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.total_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString();
    return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  });
  var tmp_4 = HomePage$render$lambda$lambda_2;
  reactiveLabel(element_1, tmp_4, ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(lastMonth);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.total_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.families_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString();
    return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  });
  var tmp_5 = HomePage$render$lambda$lambda_3;
  reactiveLabel(element_1, tmp_5, ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(lastMonth);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.breakdown_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.employerShare_1;
    var tmp;
    var tmp_0 = tmp2_safe_receiver;
    if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = Cents__toString_impl_ko5hxm(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  });
  var tmp_6 = HomePage$render$lambda$lambda_4;
  reactiveLabel(element_1, tmp_6, ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(lastMonth);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.breakdown_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.grantMatch_1;
    var tmp;
    var tmp_0 = tmp2_safe_receiver;
    if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = Cents__toString_impl_ko5hxm(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element.willAddChild_hz2iwc_k$(element_2);
  element_2.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_2 = themed(element_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Link())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_2.willAddChild_hz2iwc_k$(element_3);
  text(element_3, 'Monthly summary');
  var tmp_7 = KMutableProperty0();
  var tmp_8 = Link$_get_to_$ref_jq7esp(element_3);
  var tmp_9 = getPropertyCallableRef('to', 0, tmp_7, tmp_8, Link$_set_to_$ref_i9gu5x(element_3));
  element_3.invoke_bnq13k_k$(tmp_9, ($this$invoke) => () => new (EmployerMonthsPage())($this$invoke.invoke_r7m7el_k$(employer)._id_1));
  element_3.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_3 = themed(element_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (Link())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_3.willAddChild_hz2iwc_k$(element_4);
  text(element_4, 'Ledger');
  var tmp_10 = KMutableProperty0();
  var tmp_11 = Link$_get_to_$ref_jq7esp(element_4);
  var tmp_12 = getPropertyCallableRef('to', 0, tmp_10, tmp_11, Link$_set_to_$ref_i9gu5x(element_4));
  element_4.invoke_bnq13k_k$(tmp_12, ($this$invoke) => () => new (EmployerTransactionsPage())($this$invoke.invoke_r7m7el_k$(employer)._id_1));
  element_4.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_4);
  element_2.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_2);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda$lambda_0($this$reactiveLabel) {
  return 'Balance';
}
function HomePage$render$lambda$lambda_1($this$reactiveLabel) {
  return 'Children in care';
}
function HomePage$render$lambda$lambda_2($this$reactiveLabel) {
  return 'Employees (families) served';
}
function HomePage$render$lambda$lambda_3($this$reactiveLabel) {
  return 'Your share';
}
function HomePage$render$lambda$lambda_4($this$reactiveLabel) {
  return 'Grant match';
}
function HomePage$render$lambda_33($this$shownWhen) {
  return managesFamilies($this$shownWhen);
}
function HomePage$render$lambda_34($this$styledHeader) {
  return 'Children in care';
}
function HomePage$render$lambda_35($this$colOf, placement) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (ChildPlacementDetailPage())($this$invoke.invoke_r7m7el_k$(placement)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(placement).childName_1);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(placement).location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    var location = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    return location + ' \xB7 since ' + $this$invoke.invoke_r7m7el_k$(placement).activeRange_1.start_1.toString();
  });
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda_36($this$reactiveLabel) {
  return 'Days in care';
}
function HomePage$render$lambda_37($this$reactiveLabel) {
  return 'Cost of care';
}
function HomePage$render$lambda_38($this$colOf, entry) {
  var tmp = ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$($this$reactiveLabel.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().get_6ueaa7_k$($this$reactiveLabel.invoke_r7m7el_k$(entry).first_1));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return 'Paid by ' + (tmp1_elvis_lhs == null ? 'your employer' : tmp1_elvis_lhs);
  };
  reactiveLabel($this$colOf, tmp, ($this$reactiveLabel) => Cents__toString_impl_ko5hxm($this$reactiveLabel.invoke_r7m7el_k$(entry).second_1.amount_1));
  return Unit_instance;
}
function HomePage$render$lambda_39($this$colOf, entry) {
  var tmp = ($this$reactiveLabel) => {
    var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$($this$reactiveLabel.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$().get_6ueaa7_k$($this$reactiveLabel.invoke_r7m7el_k$(entry).first_1));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return 'Paid by ' + (tmp1_elvis_lhs == null ? 'grant' : tmp1_elvis_lhs);
  };
  reactiveLabel($this$colOf, tmp, ($this$reactiveLabel) => Cents__toString_impl_ko5hxm($this$reactiveLabel.invoke_r7m7el_k$(entry).second_1.amount_1));
  return Unit_instance;
}
function HomePage$render$lambda_40($this$reactiveLabel) {
  return 'Your portion';
}
function HomePage$render$lambda_41($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationsHeading_6tsmjb_k$();
}
function HomePage$render$lambda_42($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationsIntro_9aamv3_k$();
}
function HomePage$render$lambda_43($this$colOf, application) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (FamilyApplicationDetailPage())($this$invoke.invoke_r7m7el_k$(application)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = weight(element_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_2 = get_bold(element_1);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, HomePage$render$lambda$lambda_5);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element_1.willAddChild_hz2iwc_k$(element_3);
  element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_3);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_3));
  element_3.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).homeApplicationInvitedOn_fh8p3l_k$(renderToString($this$invoke.invoke_r7m7el_k$(application).createdAt_1, RenderSize_Abbreviation_getInstance())));
  element_3.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_3);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_3 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_3.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  var tmp_8 = themed(element_4, ChipSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_4 = dynamicThemed(tmp_8, ($this$dynamicThemed) => {
    var tmp;
    var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(application).review_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
      tmp = AffirmativeSemantic_getInstance();
    } else {
      var tmp1_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(application).review_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
        tmp = DangerSemantic_getInstance();
      } else {
        if ($this$dynamicThemed.invoke_r7m7el_k$(application).submission_1 == null) {
          tmp = WarningSemantic_getInstance();
        } else {
          tmp = null;
        }
      }
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (TextView())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  this_4.willAddChild_hz2iwc_k$(element_5);
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_5);
  var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_5));
  element_5.invoke_bnq13k_k$(tmp_11, ($this$invoke) => {
    var tmp;
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(application).review_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
      tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusApproved_5joi6n_k$();
    } else {
      var tmp1_safe_receiver = $this$invoke.invoke_r7m7el_k$(application).review_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
        tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusRejected_z7mlvs_k$();
      } else {
        if ($this$invoke.invoke_r7m7el_k$(application).submission_1 == null) {
          tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusActionNeeded_pm6rp_k$();
        } else {
          tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusSubmitted_7i53pd_k$();
        }
      }
    }
    return tmp;
  });
  element_5.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_5);
  element_4.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_5 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (TextView())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_5.willAddChild_hz2iwc_k$(element_6);
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_6);
  var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_6));
  element_6.invoke_bnq13k_k$(tmp_14, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(application).submission_1 == null && $this$invoke.invoke_r7m7el_k$(application).review_1 == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStartButton_tv1v5g_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationContinueButton_kfmgbj_k$());
  element_6.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_6);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationCardTitle_1x2b5s_k$();
}
function HomePage$render$lambda_44($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationsHeading_6tsmjb_k$();
}
function HomePage$render$lambda_45($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationsIntro_9aamv3_k$();
}
function HomePage$render$lambda_46($this$colOf, application) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => () => new (ProviderApplicationDetailPage())($this$invoke.invoke_r7m7el_k$(application)._id_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = weight(element_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_2 = get_bold(element_1);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, HomePage$render$lambda$lambda_6);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element_1.willAddChild_hz2iwc_k$(element_3);
  element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_3);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_3));
  element_3.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).homeApplicationInvitedOn_fh8p3l_k$(renderToString($this$invoke.invoke_r7m7el_k$(application).createdAt_1, RenderSize_Abbreviation_getInstance())));
  element_3.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_3);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_3 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_3.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  var tmp_8 = themed(element_4, ChipSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_4 = dynamicThemed(tmp_8, ($this$dynamicThemed) => {
    var tmp;
    var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(application).review_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
      tmp = AffirmativeSemantic_getInstance();
    } else {
      var tmp1_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(application).review_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
        tmp = DangerSemantic_getInstance();
      } else {
        if ($this$dynamicThemed.invoke_r7m7el_k$(application).submission_1 == null) {
          tmp = WarningSemantic_getInstance();
        } else {
          tmp = null;
        }
      }
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (TextView())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  this_4.willAddChild_hz2iwc_k$(element_5);
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_5);
  var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_5));
  element_5.invoke_bnq13k_k$(tmp_11, ($this$invoke) => {
    var tmp;
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(application).review_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
      tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusApproved_5joi6n_k$();
    } else {
      var tmp1_safe_receiver = $this$invoke.invoke_r7m7el_k$(application).review_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
        tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusRejected_z7mlvs_k$();
      } else {
        if ($this$invoke.invoke_r7m7el_k$(application).submission_1 == null) {
          tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusActionNeeded_pm6rp_k$();
        } else {
          tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStatusSubmitted_7i53pd_k$();
        }
      }
    }
    return tmp;
  });
  element_5.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_5);
  element_4.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_5 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (TextView())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_5.willAddChild_hz2iwc_k$(element_6);
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_6);
  var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_6));
  element_6.invoke_bnq13k_k$(tmp_14, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(application).submission_1 == null && $this$invoke.invoke_r7m7el_k$(application).review_1 == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationStartButton_tv1v5g_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeApplicationContinueButton_kfmgbj_k$());
  element_6.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_6);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function HomePage$render$lambda$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_homeProviderApplicationCardTitle_6vkqdt_k$();
}
var HomePageClass;
function HomePage() {
  if (HomePageClass === VOID) {
    class $ {
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, HomePage$_get_title_$lambda_loyj5k);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        reactive(_this__u8e3s4, VOID, ($this$reactive) => {
          var tmp;
          if ($this$reactive.invoke_r7m7el_k$(get_currentSession()) == null) {
            launch($this$reactive, VOID, VOID, HomePage$render$lambda$slambda(_this__u8e3s4));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var myFamilyApplications = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda);
        var myProviderApplications = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda_0);
        var today_0 = nowLocal().get_date_wokkxj_k$();
        var soon = plus(today_0, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 30));
        var awaitingApproval = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda_1);
        var overdueAttendance = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!isBackOfficeUser($this$remember)) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var tmp_0 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$3);
          var tmp_2 = and(eq(get_submitted(it), null), lt(get_endInclusive(get_period(it)), today_0));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$10 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$10);
          this_0.ascending_ijynum_k$(get_start(get_period(it_0)));
          var tmp$ret$6 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp_2, tmp$ret$6)));
        });
        var submittedFamilyApplications = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda_2);
        var submittedProviderApplications = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda_3);
        var placementsEnding = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!isBackOfficeUser($this$remember)) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var tmp_0 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$15 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$15);
          var tmp_2 = and(and(eq(get_active(it), true), gte(get_notNull(get_endInclusive_0(get_activeRange(it))), today_0)), lte(get_notNull(get_endInclusive_0(get_activeRange(it))), soon));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$22);
          this_0.ascending_ijynum_k$(get_notNull(get_endInclusive_0(get_activeRange(it_0))));
          var tmp$ret$18 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp_2, tmp$ret$18)));
        });
        var authorizationsEnding = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!isBackOfficeUser($this$remember)) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var tmp_0 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyEmployerAuthorizations_srfp8e_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$27);
          var tmp_2 = and(gte(get_endInclusive(get_activeRange_0(it)), today_0), lte(get_endInclusive(get_activeRange_0(it)), soon));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$34 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$34);
          this_0.ascending_ijynum_k$(get_endInclusive(get_activeRange_0(it_0)));
          var tmp$ret$30 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp_2, tmp$ret$30)));
        });
        var openAttendance = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!(managesLocations($this$remember) || managesProviders($this$remember))) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var tmp_0 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$39 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$39);
          var tmp_2 = and(eq(get_approved(it), null), lte(get_start(get_period(it)), today_0));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$46 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$46);
          this_0.ascending_ijynum_k$(get_start(get_period(it_0)));
          var tmp$ret$42 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp_2, tmp$ret$42)));
        });
        var enrolledByLocation = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!(managesLocations($this$remember) || managesProviders($this$remember))) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var tmp_0 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$51 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$51);
          var tmp$ret$49 = and(and(eq(get_active(it), true), lte(get_start_0(get_activeRange(it)), today_0)), or(eq(get_endInclusive_0(get_activeRange(it)), null), gte(get_notNull(get_endInclusive_0(get_activeRange(it))), today_0)));
          // Inline function 'kotlin.collections.groupingBy' call
          var this_0 = $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp$ret$49, VOID, VOID, 2147483647)));
          var tmp$ret$54 = new (HomePage$render$1$$inlined$groupingBy$1())(this_0);
          return toList(eachCount(tmp$ret$54));
        });
        var upcomingClosures = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!(managesLocations($this$remember) || managesProviders($this$remember))) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var tmp_0 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationClosures_im9skn_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
          var tmp$ret$58 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$58);
          var tmp_2 = and(gte(get_date(it), today_0), lte(get_date(it), soon));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
          var tmp$ret$65 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$65);
          this_0.ascending_ijynum_k$(get_date(it_0));
          var tmp$ret$61 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp_2, tmp$ret$61)));
        });
        var myEmployers = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda_4);
        var familyPlacements = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!managesFamilies($this$remember)) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          }
          var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
          var families = $this$remember.invoke_r7m7el_k$(session.managedFamilies_1);
          var tmp_0 = session.get_childrenPlacement_hazabn_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$70 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$70);
          var tmp_2 = and(and(xDataClassPathInsideSet(get_family_0(it), families), eq(get_active(it), true)), or(eq(get_endInclusive_0(get_activeRange(it)), null), gte(get_notNull(get_endInclusive_0(get_activeRange(it))), today_0)));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$77 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$77);
          this_0.ascending_ijynum_k$(get_childName(it_0));
          var tmp$ret$73 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp_2, tmp$ret$73)));
        });
        var startOfYear = LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(today_0.year_1, 1, 1);
        var familyBenefitThisYear = rememberSuspending(VOID, VOID, VOID, HomePage$render$slambda(startOfYear));
        var employerBenefit = remember(VOID, VOID, VOID, VOID, ($this$remember) => toList($this$remember.invoke_r7m7el_k$(familyBenefitThisYear).employers_1));
        var grantBenefit = remember(VOID, VOID, VOID, VOID, ($this$remember) => toList($this$remember.invoke_r7m7el_k$(familyBenefitThisYear).grants_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, HomePage$render$lambda_5);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        var openSurveys = remember(VOID, VOID, VOID, VOID, HomePage$render$lambda_6);
        var toTake = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$(get_currentSession());
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var session = tmp;
          var self_0 = $this$remember.invoke_r7m7el_k$(session.self_1);
          var tmp_0 = session.get_surveyProgresses_a5rnfi_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(SurveyProgress()), arrayOf([]), false));
          var tmp$ret$91 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$91);
          var tmp$ret$89 = neq(get_takerType(it), Audience_AnonymousEmployee_getInstance());
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.invoke_r7m7el_k$(tmp_0.query_so6xq1_k$(new (Query())(tmp$ret$89, VOID, VOID, 2147483647)));
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var key = to(new (ID_4())(element.survey_1), element.takerId_1);
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.get_wei43m_k$(key);
            var tmp_2;
            if (value == null) {
              var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
              destination.put_4fpzoq_k$(key, answer);
              tmp_2 = answer;
            } else {
              tmp_2 = value;
            }
            var list = tmp_2;
            list.add_utx5q5_k$(element);
          }
          // Inline function 'kotlin.collections.mapValues' call
          // Inline function 'kotlin.collections.mapValuesTo' call
          var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(destination.get_size_woubt6_k$()));
          // Inline function 'kotlin.collections.associateByTo' call
          var _iterator__ex2g4s_0 = destination.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp_3 = element_0.get_key_18j28a_k$();
            // Inline function 'kotlin.collections.component2' call
            var takings = element_0.get_value_j01efc_k$();
            var tmp$ret$105;
            $l$block: {
              // Inline function 'kotlin.collections.maxBy' call
              var iterator = takings.iterator_jk1svi_k$();
              if (!iterator.hasNext_bitz1p_k$())
                throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
              var maxElem = iterator.next_20eer_k$();
              if (!iterator.hasNext_bitz1p_k$()) {
                tmp$ret$105 = maxElem;
                break $l$block;
              }
              var maxValue = maxElem.takerIteration_1;
              do {
                var e = iterator.next_20eer_k$();
                var v = e.takerIteration_1;
                if (compareTo(maxValue, v) < 0) {
                  maxElem = e;
                  maxValue = v;
                }
              }
               while (iterator.hasNext_bitz1p_k$());
              tmp$ret$105 = maxElem;
            }
            var tmp$ret$103 = tmp$ret$105;
            destination_0.put_4fpzoq_k$(tmp_3, tmp$ret$103);
          }
          var latest = destination_0;
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0_0 = $this$remember.invoke_r7m7el_k$(openSurveys);
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
            var tmp_4;
            switch (element_1.audience_1.ordinal_1) {
              case 1:
                // Inline function 'kotlin.collections.map' call

                var this_0 = self_0.managesFamilies_1;
                // Inline function 'kotlin.collections.mapTo' call

                var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
                var _iterator__ex2g4s_2 = this_0.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
                  var item = _iterator__ex2g4s_2.next_20eer_k$();
                  var it_0 = item.raw_1;
                  var tmp$ret$113 = _ID___get_raw__impl__92g6u5(it_0);
                  destination_2.add_utx5q5_k$(tmp$ret$113);
                }

                tmp_4 = destination_2;
                break;
              case 2:
                // Inline function 'kotlin.collections.map' call

                var this_1 = self_0.managesEmployers_1;
                // Inline function 'kotlin.collections.mapTo' call

                var destination_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
                var _iterator__ex2g4s_3 = this_1.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
                  var item_0 = _iterator__ex2g4s_3.next_20eer_k$();
                  var it_1 = item_0.raw_1;
                  var tmp$ret$116 = _ID___get_raw__impl__92g6u5_0(it_1);
                  destination_3.add_utx5q5_k$(tmp$ret$116);
                }

                tmp_4 = destination_3;
                break;
              case 3:
                // Inline function 'kotlin.collections.map' call

                var this_2 = self_0.managesProviders_1;
                // Inline function 'kotlin.collections.mapTo' call

                var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
                var _iterator__ex2g4s_4 = this_2.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
                  var item_1 = _iterator__ex2g4s_4.next_20eer_k$();
                  var it_2 = item_1.raw_1;
                  var tmp$ret$119 = _ID___get_raw__impl__92g6u5_1(it_2);
                  destination_4.add_utx5q5_k$(tmp$ret$119);
                }

                tmp_4 = destination_4;
                break;
              case 0:
                // Inline function 'kotlin.collections.listOf' call

                tmp_4 = emptyList();
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            var takers = tmp_4;
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_5 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(takers, 10));
            var _iterator__ex2g4s_5 = takers.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
              var item_2 = _iterator__ex2g4s_5.next_20eer_k$();
              var tmp$ret$123 = to(element_1, item_2);
              destination_5.add_utx5q5_k$(tmp$ret$123);
            }
            var list_0 = destination_5;
            addAll(destination_1, list_0);
          }
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_6 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_6 = destination_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
            var element_2 = _iterator__ex2g4s_6.next_20eer_k$();
            var tmp$ret$126;
            $l$block_0: {
              var survey = element_2.component1_7eebsc_k$();
              var takerId = element_2.component2_7eebsb_k$();
              var tmp0_safe_receiver = latest.get_wei43m_k$(to(new (ID_4())(survey._id_1), takerId));
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.completedAt_1;
              var tmp_5;
              if (tmp1_elvis_lhs == null) {
                tmp$ret$126 = true;
                break $l$block_0;
              } else {
                tmp_5 = tmp1_elvis_lhs;
              }
              var completedAt = tmp_5;
              var tmp2_safe_receiver = nextTakingDate(survey, completedAt);
              var tmp_6;
              if (tmp2_safe_receiver == null) {
                tmp_6 = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp_6 = tmp2_safe_receiver.compareTo_e7gwgq_k$(today()) <= 0;
              }
              tmp$ret$126 = tmp_6 === true;
            }
            if (tmp$ret$126) {
              destination_6.add_utx5q5_k$(element_2);
            }
          }
          return destination_6;
        });
        var tmp_2 = HomePage$render$lambda_7;
        colOf(element, toTake, tmp_2, VOID, VOID, HomePage$render$lambda_8);
        var toShare = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(get_currentSession());
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.invoke_r7m7el_k$(tmp0_safe_receiver.self_1);
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.managesEmployers_1;
          var tmp;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          } else {
            tmp = tmp2_elvis_lhs;
          }
          var employers = tmp;
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.invoke_r7m7el_k$(openSurveys);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.audience_1.equals(Audience_AnonymousEmployee_getInstance())) {
              destination.add_utx5q5_k$(element);
            }
          }
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(employers, 10));
            var _iterator__ex2g4s_1 = employers.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
              var item = _iterator__ex2g4s_1.next_20eer_k$();
              var it = item.raw_1;
              var tmp$ret$138 = to(element_0, new (ID_2())(it));
              destination_1.add_utx5q5_k$(tmp$ret$138);
            }
            var list = destination_1;
            addAll(destination_0, list);
          }
          return destination_0;
        });
        var tmp_3 = HomePage$render$lambda_9;
        colOf(element, toShare, tmp_3, VOID, VOID, HomePage$render$lambda_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !managesSomething($this$shownWhen) && $this$shownWhen.invoke_r7m7el_k$(myFamilyApplications).isEmpty_y1axqb_k$() && $this$shownWhen.invoke_r7m7el_k$(myProviderApplications).isEmpty_y1axqb_k$());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_1.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_1.willAddChild_hz2iwc_k$(element_3);
        element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_6 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_6, HomePage$render$lambda_11);
        element_3.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_3);
        element_1.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_2 = shownWhen(element, VOID, VOID, HomePage$render$lambda_12);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_2.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Space())(element_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element_4.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        element_4.addChild_2qpft2_k$(element_5);
        h1(element_4, 'Needs attention');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_3 = shownWhen(element_4, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(awaitingApproval).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_3.willAddChild_hz2iwc_k$(element_6);
        element_6.set_vertical_nuap32_k$(true);
        styledHeader(element_6, HomePage$render$lambda_13);
        colOf_0(element_6, awaitingApproval, VOID, VOID, VOID, HomePage$render$lambda_14);
        element_6.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element_4, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(overdueAttendance).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_4.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        styledHeader(element_7, HomePage$render$lambda_15);
        colOf_0(element_7, overdueAttendance, VOID, VOID, VOID, HomePage$render$lambda_16);
        element_7.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_5 = shownWhen(element_4, VOID, VOID, ($this$shownWhen) => {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$shownWhen.invoke_r7m7el_k$(submittedFamilyApplications).isEmpty_y1axqb_k$()) {
            tmp = true;
          } else {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp = !$this$shownWhen.invoke_r7m7el_k$(submittedProviderApplications).isEmpty_y1axqb_k$();
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_5.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(true);
        styledHeader(element_8, HomePage$render$lambda_17);
        colOf_0(element_8, submittedFamilyApplications, VOID, VOID, VOID, HomePage$render$lambda_18);
        colOf_0(element_8, submittedProviderApplications, VOID, VOID, VOID, HomePage$render$lambda_19);
        element_8.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_6 = shownWhen(element_4, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(placementsEnding).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_6.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(true);
        styledHeader(element_9, HomePage$render$lambda_20);
        colOf_0(element_9, placementsEnding, VOID, VOID, VOID, HomePage$render$lambda_21);
        element_9.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_7 = shownWhen(element_4, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(authorizationsEnding).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_7.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(true);
        styledHeader(element_10, HomePage$render$lambda_22);
        colOf_0(element_10, authorizationsEnding, VOID, VOID, VOID, HomePage$render$lambda_23);
        element_10.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (RowOrCol())(element_4.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_4.willAddChild_hz2iwc_k$(element_11);
        element_11.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_8 = themed(element_11, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Link())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_8.willAddChild_hz2iwc_k$(element_12);
        text(element_12, 'Close out the month');
        var tmp_7 = KMutableProperty0();
        var tmp_8 = Link$_get_to_$ref_jq7esp(element_12);
        var tmp_9 = getPropertyCallableRef('to', 0, tmp_7, tmp_8, Link$_set_to_$ref_i9gu5x(element_12));
        element_12.invoke_bnq13k_k$(tmp_9, HomePage$render$lambda_24);
        element_12.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_12);
        element_11.onStartup_vrxh3i_k$();
        element_4.addChild_2qpft2_k$(element_11);
        element_4.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_9 = shownWhen(element, VOID, VOID, HomePage$render$lambda_25);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_9.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (Space())(element_13.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        element_13.willAddChild_hz2iwc_k$(element_14);
        element_14.onStartup_vrxh3i_k$();
        element_13.addChild_2qpft2_k$(element_14);
        h1(element_13, 'Your care locations');
        styledHeader(element_13, HomePage$render$lambda_26);
        subtext(shownWhen(element_13, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(openAttendance).isEmpty_y1axqb_k$()), 'All attendance is submitted and approved.');
        colOf_0(element_13, openAttendance, VOID, VOID, VOID, HomePage$render$lambda_27);
        styledHeader(element_13, HomePage$render$lambda_28);
        subtext(shownWhen(element_13, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(enrolledByLocation).isEmpty_y1axqb_k$()), 'No children are enrolled.');
        colOf_0(element_13, enrolledByLocation, VOID, VOID, VOID, HomePage$render$lambda_29);
        styledHeader(element_13, HomePage$render$lambda_30);
        subtext(shownWhen(element_13, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(upcomingClosures).isEmpty_y1axqb_k$()), 'No closures scheduled.');
        colOf_0(element_13, upcomingClosures, VOID, VOID, VOID, HomePage$render$lambda_31);
        element_13.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(myEmployers).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_10.willAddChild_hz2iwc_k$(element_15);
        element_15.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (Space())(element_15.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_15.willAddChild_hz2iwc_k$(element_16);
        element_16.onStartup_vrxh3i_k$();
        element_15.addChild_2qpft2_k$(element_16);
        colOf_0(element_15, myEmployers, VOID, VOID, VOID, HomePage$render$lambda_32);
        element_15.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = shownWhen(element, VOID, VOID, HomePage$render$lambda_33);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        this_11.willAddChild_hz2iwc_k$(element_17);
        element_17.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (Space())(element_17.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        element_17.willAddChild_hz2iwc_k$(element_18);
        element_18.onStartup_vrxh3i_k$();
        element_17.addChild_2qpft2_k$(element_18);
        h1(element_17, 'Your family');
        styledHeader(element_17, HomePage$render$lambda_34);
        subtext(shownWhen(element_17, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(familyPlacements).isEmpty_y1axqb_k$()), 'No children are currently placed in care.');
        colOf_0(element_17, familyPlacements, VOID, VOID, VOID, HomePage$render$lambda_35);
        styledHeader(element_17, ($this$styledHeader) => 'Your benefit in ' + today_0.year_1);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = themed(element_17, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        this_12.willAddChild_hz2iwc_k$(element_19);
        element_19.set_vertical_nuap32_k$(true);
        var tmp_10 = HomePage$render$lambda_36;
        reactiveLabel(element_19, tmp_10, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(familyBenefitThisYear).days_1.toString());
        var tmp_11 = HomePage$render$lambda_37;
        reactiveLabel(element_19, tmp_11, ($this$reactiveLabel) => Cents__toString_impl_ko5hxm($this$reactiveLabel.invoke_r7m7el_k$(familyBenefitThisYear).price_1));
        colOf_0(element_19, employerBenefit, VOID, VOID, VOID, HomePage$render$lambda_38);
        colOf_0(element_19, grantBenefit, VOID, VOID, VOID, HomePage$render$lambda_39);
        var tmp_12 = HomePage$render$lambda_40;
        reactiveLabel(element_19, tmp_12, ($this$reactiveLabel) => Cents__toString_impl_ko5hxm($this$reactiveLabel.invoke_r7m7el_k$(familyBenefitThisYear).paidByFamily_1));
        element_19.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_19);
        element_17.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(myFamilyApplications).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        this_13.willAddChild_hz2iwc_k$(element_20);
        element_20.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (Space())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        element_20.willAddChild_hz2iwc_k$(element_21);
        element_21.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_21);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_22 = new (TextView())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_22);
        element_20.willAddChild_hz2iwc_k$(element_22);
        element_22.set_themeChoice_py59um_k$(element_22.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp_13 = KMutableProperty0();
        var tmp_14 = TextView$_get_content_$ref_4pzcwl(element_22);
        var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb(element_22));
        element_22.invoke_bnq13k_k$(tmp_15, HomePage$render$lambda_41);
        element_22.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_22);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_23 = new (TextView())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_23);
        element_20.willAddChild_hz2iwc_k$(element_23);
        element_23.set_themeChoice_py59um_k$(element_23.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_16 = KMutableProperty0();
        var tmp_17 = TextView$_get_content_$ref_4pzcwl(element_23);
        var tmp_18 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb(element_23));
        element_23.invoke_bnq13k_k$(tmp_18, HomePage$render$lambda_42);
        element_23.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_23);
        colOf_0(element_20, myFamilyApplications, VOID, VOID, VOID, HomePage$render$lambda_43);
        element_20.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_20);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(myProviderApplications).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_24 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_24);
        this_14.willAddChild_hz2iwc_k$(element_24);
        element_24.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_25 = new (Space())(element_24.get_context_h02k06_k$());
        ensureOutermostElement(element_25);
        element_24.willAddChild_hz2iwc_k$(element_25);
        element_25.onStartup_vrxh3i_k$();
        element_24.addChild_2qpft2_k$(element_25);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_26 = new (TextView())(element_24.get_context_h02k06_k$());
        ensureOutermostElement(element_26);
        element_24.willAddChild_hz2iwc_k$(element_26);
        element_26.set_themeChoice_py59um_k$(element_26.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp_19 = KMutableProperty0();
        var tmp_20 = TextView$_get_content_$ref_4pzcwl(element_26);
        var tmp_21 = getPropertyCallableRef('content', 0, tmp_19, tmp_20, TextView$_set_content_$ref_pketfb(element_26));
        element_26.invoke_bnq13k_k$(tmp_21, HomePage$render$lambda_44);
        element_26.onStartup_vrxh3i_k$();
        element_24.addChild_2qpft2_k$(element_26);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_27 = new (TextView())(element_24.get_context_h02k06_k$());
        ensureOutermostElement(element_27);
        element_24.willAddChild_hz2iwc_k$(element_27);
        element_27.set_themeChoice_py59um_k$(element_27.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_22 = KMutableProperty0();
        var tmp_23 = TextView$_get_content_$ref_4pzcwl(element_27);
        var tmp_24 = getPropertyCallableRef('content', 0, tmp_22, tmp_23, TextView$_set_content_$ref_pketfb(element_27));
        element_27.invoke_bnq13k_k$(tmp_24, HomePage$render$lambda_45);
        element_27.onStartup_vrxh3i_k$();
        element_24.addChild_2qpft2_k$(element_27);
        colOf_0(element_24, myProviderApplications, VOID, VOID, VOID, HomePage$render$lambda_46);
        element_24.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_24);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
      }
    }
    initMetadataForClass($, 'HomePage', HomePage, VOID, [Page()]);
    HomePageClass = $;
  }
  return HomePageClass;
}
//region block: exports
export {
  HomePage as HomePage3ptt6l367zajb,
};
//endregion

//# sourceMappingURL=HomeScreen.mjs.map
